// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.11959"][{"3591":0}[chunkId]] || "1.11962") + "/" + chunkId + ".js";
};